import React, { useEffect, useState, useRef } from "react";

const Timer = ({ startTime, confLeave, endTime }) => {
  const intervalRef = useRef(null);
  const [stopTime, setStopTime] = useState(null);

  const calculateTime = () => {
    const sTime = Number(startTime);
    if (!sTime) return "00:00:00";

    const nowSeconds = Math.floor(Date.now() / 1000);
    const explicitEnd = endTime ? Number(endTime) : null;
    const endSeconds = explicitEnd ?? stopTime ?? nowSeconds;
    const diff = endSeconds - sTime;

    const hours = String(Math.floor(diff / 3600)).padStart(2, "0");
    const minutes = String(Math.floor((diff % 3600) / 60)).padStart(2, "0");
    const seconds = String(diff % 60).padStart(2, "0");

    return `${hours}:${minutes}:${seconds}`;
  };

  // set the correct initial time
  const [time, setTime] = useState(calculateTime);

  useEffect(() => {
    if (endTime) {
      setStopTime(null);
      if (intervalRef.current) clearInterval(intervalRef.current);
      return;
    }

    if (confLeave === "1") {
      if (!stopTime) setStopTime(Math.floor(Date.now() / 1000));
      if (intervalRef.current) clearInterval(intervalRef.current);
      return;
    }

    if (stopTime) setStopTime(null);

    if (!startTime || startTime === "0") return;

    intervalRef.current = setInterval(() => {
      if (confLeave === "1") {
        clearInterval(intervalRef.current);
        return;
      }
      setTime(calculateTime());
    }, 1000);

    return () => clearInterval(intervalRef.current);
  }, [startTime, confLeave, endTime, stopTime]);

  return <span>{time}</span>;
};

export default Timer;
